<template>
  <nav
    class="price-category-nav bg-gray-0 rounded-20 px-4 py-6 align-self-start"
    :class="{ 'price-category-nav--v5': ff_lpu_branding_page_v5 }"
    data-qa="lpu_page_price_categories"
  >
    <div class="text-subtitle-2 text-info--text pl-4 pb-3">
      {{ tStatic('Категория') }}
    </div>
    <button
      v-for="item in items"
      :key="item.name"
      type="button"
      class="price-category-nav__item d-flex align-center text-left w-100 pa-4"
      :class="{
        'price-category-nav__item--active rounded-10': item.name === activeName,
      }"
      data-qa="lpu_page_price_category_item"
      @click="onSelect(item.name)"
    >
      <span class="price-category-nav__name text-body-1 min-w-0">{{ item.name }}</span>
    </button>
  </nav>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { PriceCategoryNavItem } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/functions/getCategoryNavItems'

type Emits = {
  (_event: 'select', _name: string): void
  (_event: 'select:default'): void
}

const props = defineProps<{
  items: PriceCategoryNavItem[]
  activeName?: string
}>()

const emit = defineEmits<Emits>()

const { context }: CommonContextStore = useContextStore()
const ff_lpu_branding_page_v5 = computed(() => (
  Boolean(context.request.feature_flags.ff_lpu_branding_page_v5)
))

function onSelect(name: string) {
  if (name === props.activeName) {
    emit('select:default')

    return
  }

  emit('select', name)
}
</script>

<style scoped lang="scss">
@import 'src/styles/variables';

.price-category-nav {
  // Фиксированная ширина в flex-ряду: иначе min-width:auto / shrink
  // тянут сайдбар за контентом списка услуг.
  flex: 0 0 312px;
  width: 312px;
  max-width: 312px;
  min-width: 0;

  // shadow new из макета
  box-shadow:
    0 1px 2px rgba(5, 23, 40, 0.08),
    0 0 2px rgba(21, 40, 92, 0.06),
    0 2px 24px rgba(9, 42, 72, 0.08);

  &__item {
    border: 0;
    background: transparent;
    cursor: pointer;
    color: $ui-kit-text;
    font: inherit;
    min-width: 0;
  }

  &__name {
    word-break: break-word;
  }

  &__item--active {
    background-color: var(--lpu-branding-color-background);
    color: var(--lpu-branding-color-primary);
  }

  &--v5 &__item--active {
    color: var(--lpu-branding-color-text);
  }
}
</style>
